import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';
import {ReactiveServiceWithFilters} from '../reactive-service-with-filters.abstract';
import { MultipleRESTService } from '../../../../src/app/API/apiService';
import {ApplicationModel} from './application.model';
import {tap} from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class ApplicationsApiService extends ReactiveServiceWithFilters implements Resolve<ApplicationModel[]>, MultipleRESTService<ApplicationModel[]> {
  protected baseUrl = environment.backEndUrlPrefix + '/' + 'application';

  private config?: ApplicationModel[] = undefined;
  constructor(protected http: HttpClient) {
    super();
  }

  getAll(): Observable<ApplicationModel[]> {
    return this.http.get<ApplicationModel[]>(this.buildUrl(this.baseUrl)).pipe(tap(cfg => this.config = cfg));
  }
  getAllWithCache(): Observable<ApplicationModel[]> {
    if (this.config) {
      return of<ApplicationModel[]>(this.config);
    }
    return this.getAll();
  }

  updateGroup(ids: number[], data): Observable<ApplicationModel[]> {
    return this.http.patch<ApplicationModel[]>(this.baseUrl, data, {params: {id: ids.map(id => id.toString())}});
  }

  deleteGroup(ids: number[]): Observable<string> {
    return this.http.delete<string>(this.baseUrl, {params: {id: ids.map(id => String(id))}});
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ApplicationModel[]> | Promise<ApplicationModel[]> | ApplicationModel[] {
    return this.getAll();
  }

}
